import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';import {AuthService} from './auth.service';
import {AngularFireStorage} from '@angular/fire/compat/storage';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';

@Injectable({
    providedIn: 'root'
})
export class BannerSponsorService {

    public objectImage: any = null;
    public storedImage: any = null;

    public spinner: boolean = false;

    public uniqueId: string = 'UK1mL8hS6njr1gtEp28F';

    constructor (
        private db: AngularFirestore,
        private fs: AngularFireStorage,
        public _authService: AuthService,
        private snackBar: SnackBarIconService
    ) { }


    getUnique () {
        return this.db.doc<Event>('sbccv_banner_sponsors/' + this.uniqueId)
            .get();
    }

    updateBannerSponsor(banners){
       // console.log("id: " + this.uniqueId)
        //console.log("banners: " + JSON.stringify(banners))

        return this.db.collection('sbccv_banner_sponsors').doc(this.uniqueId).set(Object.assign({}, {'sponsors': banners}), {merge: true})
            .then(() => {
                this.snackBar.openSnackBar("Sucesso!", '', 'success');
            })
            .catch((error) => {
                console.log("activity update banner error: " + JSON.stringify(error))
                this.snackBar.openSnackBar("Erro", '', 'error');
            })
    }
}
